import { create } from 'zustand';

import { AuthPageEnum } from '@/components/CandidateAuth/AuthEnum';

type AuthDialogStore = {
  isOpen: boolean;
  defaultPage: AuthPageEnum;
  setIsOpen: (open: boolean) => void;
  openWithPage: (page: AuthPageEnum) => void;
};

export const useAuthDialogStore = create<AuthDialogStore>()((set) => ({
  isOpen: false,
  defaultPage: AuthPageEnum.LOGIN_PROVIDERS,
  setIsOpen: (open) => set({ isOpen: open }),
  openWithPage: (page) => set({ isOpen: true, defaultPage: page }),
}));
